module.exports = __webpack_public_path__ + "fonts/AkkuratLL-Italic.5cd6d625.otf";